import {useTranslation} from 'react-i18next';
import {useInstance} from 'react-ioc';
import {Button} from 'antd';
import {observer} from 'mobx-react-lite';

import {Store} from '../../../model/store/Store';
import {CurrencyFormat, CurrencySymbol} from '../../../shared/helpers/currencies';

import {IOffer} from './Cards';

import cls from './Cards.module.scss'


export const Card = observer(({name, logo, from, to, percent, date, age, URL}: IOffer) => {

    const {t} = useTranslation();
    const {rate} = useInstance(Store)

    function CurrencyConvert (value: number, current:string, selected:string): number{
        if (current === selected) {
            return value
        } else {
            // @ts-ignore
            const valueUSD = value / rate.rates[current]
            // @ts-ignore
            return valueUSD * rate.rates[selected]
        }
    }

    const textFrom = `${CurrencyFormat(CurrencyConvert(from.value, from.currency, rate.currency))} ${CurrencySymbol(rate.currency)}`
    const textTo = `${CurrencyFormat(CurrencyConvert(to.value, from.currency, rate.currency))} ${CurrencySymbol(rate.currency)}`

    return (
        <div className={cls.card}>
            <div className={cls.wrapper}>

                <img className={cls.logo} src={logo} alt={name}/>

                <div className={cls.title}>{t('From {{from}} to {{to}}', {from: textFrom, to: textTo})}</div>

                <div className={cls.line}><span>{t('Bid')}</span><span className={'bold'}>{percent}</span></div>
                <div className={cls.line}><span>{t('Term')}</span><span className={'bold'}>{date}</span></div>
                <div className={cls.line}><span>{t('Age')}</span><span className={'bold'}>{age}</span></div>

                <a href={URL} target={'_blank'} rel={'noreferrer'}><Button type={'primary'} size={'large'} block>{t('Get money')}</Button></a>

            </div>
        </div>
    )
})